import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormControl,
  Switch,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%',
  },
  formRow: {
    margin: '5px 0',
    justifyContent: 'space-between',
  },
}))

const getDisplay = type => {
  switch (type.toLowerCase()) {
    case 'switch':
      return Switch
    case 'checkbox':
      return Checkbox
    default:
      return Checkbox
  }
}

function MultipleValueFilter({ options, values, setValues, type }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const onClick = value => () => {
    let newValues
    if (values.includes(value)) {
      newValues = values.filter(oldValue => oldValue !== value)
    } else {
      newValues = [...values, value]
    }
    setValues(newValues)
  }

  const renderDisplayComponent = ({ value, disabled }) => {
    const DisplayComponent = getDisplay(type)

    return (
      <FormControlLabel
        className={classes.formRow}
        disabled={disabled}
        key={value}
        control={
          <DisplayComponent
            className={classes.interactiveElement}
            color="primary"
            checked={values.includes(value)}
            onClick={onClick(value)}
            value={value}
          />
        }
        label={t(`filters.valueMappings.${value}`)}
        labelPlacement="start"
      />
    )
  }

  return (
    <FormControl component="fieldset" key="checkbox::form" className={classes.form}>
      <FormGroup>{options.map(renderDisplayComponent)}</FormGroup>
    </FormControl>
  )
}


export default MultipleValueFilter
